import React, { useEffect, useState } from 'react'
import VideoModal from '../../HomePages/home-one/section/videoModal';
import { Link, useLocation, useParams } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { all_routes } from '../../router/all_routes';
import WhyStudyAbroad from './WhyStudyAbroad'
import Aboutsection from './aboutsection'
import IndividualUniversity from './IndividualUniversity'
import CountUp from 'react-countup'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useGetIndividualSubjectApiQuery } from '../../../core/Features/api/findACourse/individual/individualSubject';
import Whatsnew from './whatsnew';
import Whatsnew2 from './whatsnew2';
import Unlock from '../../HomePages/home-palani/section/Unlock';

// import Destination from './Destination'
// import Whatsnew from './whatsnew'
// import Benefits from './Benefits'
// import About from './about-us'

const IndividualSubject = () => {

    const { id } = useParams();
    const { data, isLoading, isError } = useGetIndividualSubjectApiQuery(id || {});


    const apiValues = data?.data || {};


    const [showModal, setShowModal] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/1trvO6dqQUI';

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const route = all_routes;

    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animate only once
        });
    }, []);
  // 1️⃣ Loading state
  if (isLoading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  // 2️⃣ Error or no data → Show page not exists
  if (isError || !apiValues || Object.keys(apiValues).length === 0) {
    return (
      <div className="text-center py-20">
        <h1 className="text-3xl font-bold">Page Not Found</h1>
        <p className="mt-2 text-gray-500">
          The page you are looking for doesn’t exist.
        </p>
        <Link to="/home" className="btn btn-primary mt-4">
          Go Back Home
        </Link>
      </div>
    );
  }

    return (
        <>
            <>

                {/* banner */}
                <section className="relative py-10 sm:py-20">
                    {/* Dynamic Background Image */}
                    <div
                        className="absolute inset-0 bg-no-repeat z-[-1]"
                        style={{
                            backgroundImage: `url(${apiValues?.bannerImageUrl})`,
                                                        backgroundSize:"100% 100%",

                        }}
                    />

                    {/* Optional: Dark Overlay */}
                    <div className="absolute inset-0 bg-black/60 z-[-1]" />

                    {/* Content */}
                    <div className="container relative">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="d-sm-flex align-items-center justify-content-sm-between mt-5">
                                    <div className="d-flex text-start align-items-center justify-content-sm-start justify-content-center">
                                        <div className="ms-2">
                                            <h6 className="fs-18 text-white">
                                                {apiValues?.bannerTitle}
                                            </h6>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='p-3'>

                    <WhyStudyAbroad apiValues={apiValues} />
                    <Aboutsection apiValues={apiValues} />
                    <IndividualUniversity apiValues={apiValues} />

                    {/* top university */}
                    <Whatsnew apiValues={apiValues} />

                    {/* scholarship */}
                    <Whatsnew2 apiValues={apiValues} />

                    <Unlock />

                </div>

            </>

        </>
    )
}

export default IndividualSubject




